import React, { useEffect, useState } from "react";
import API from '../Services/RefundReason'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import RefundReasonList from "../Components/RefundReasonList";


const RefundReason = () => {
    const [reason, setReason] = useState("")
    const [error, setError] = useState({});
    const [reasonList, setReasonList] = useState([])
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 10
    const [id, setId] = useState([])
    const [isEditing, setIsEditing] = useState(false);
    const [highlight, setHighlight] = useState(false);

    useEffect(() => {
        getRefundReasonList()
    }, [currentPage])



    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...(prevErrors || {}) };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }
        switch (fieldName) {
            case "reason":
                setReason(value);
                break;
            default:
                break;
        }
    };

    const validateFields = () => {
        const errors = {};
        if (!reason.trim()) {
            errors.reason = "Refund Reason is required";
        } else if (!/^[a-zA-Z][a-zA-Z0-9 _%-&]*$/.test(reason)) {
            errors.reason = "Enter a valid Refund Reason (must start with a letter)";
        }
        // if (!(reason?.trim())) errors.reason = "Reason is required";
        setError(errors);
        return Object.keys(errors).length === 0;
    }

    const addRefundReason = async () => {
        if (!validateFields()) return;
        const payload = {
            reason: reason,
        }
        try {
            const response = await API.createRefund(payload);
            // console.log("response refund", response?.data?.data)
            if (response?.status === 200) {
                toast.success(response?.data?.message || "Refund Reason successful!");
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Refund Reason failed.");
            }
        } catch (error) {
            console.error("Axios error:", error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            if (error.response) {
                console.error("Response data:", error.response.data);
                console.error("Response status:", error.response.status);

                const errorMessage =
                    error.response.data?.message || `Error: ${error.response.status}`;
                toast.error(errorMessage);
            } else if (error.request) {
                console.error("Request error:", error.request);
                toast.error("No response from server. Please try again later.");
            } else {
                console.error("Error message:", error.message);
                toast.error("Something went wrong. Please try again.");
            }
        }
    };
    const handleError = (error) => {
        // console.error("Error:", error);
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };

    const getRefundReasonList = async () => {
        try {
            const payload = {
                limit: perPage,
                pageNumber: currentPage
            };
            const response = await API.getRefundReason(payload);
            setReasonList(response?.data?.data?.rows)
            setTotalRecords(response?.data?.data?.count)
        } catch (error) {
            toast.dismiss();
            if (!error.response) {
                toast.error("Network error! Please check your internet connection");
            } else if (error.response.status === 403) {
                window.location.replace("/Login")
                toast.error("Network error! Please check your internet connection.");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };
    const totalPages = Math.ceil(totalRecords / perPage);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            // getRefundReasonList();
        }
    };



    const handleSubmit = async () => {
        if (!validateFields()) return;
        await addRefundReason();
    };

    const handleCancel = () => {
        setReason('');
        setId(null);
        setIsEditing(false);
        window.location.reload();
    };

    return (
        <div>
            <div >
                <div className="col-12 grid-margin stretch-card">
                    <div className="card">
                        <div
                            className={`card ${highlight ? "highlight" : ""}`}
                            style={{
                                backgroundColor: highlight ? "#fff" : "white",
                                transition: "background-color 0.3s ease",
                            }}
                        >
                            <div className="card-body">

                                <div className="forms-sample">
                                    <div className="row">
                                        <div className="col-md-8">
                                            <div className="form-group">
                                                <label htmlFor="name">Refund Reason <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="txtreason"
                                                    placeholder="Refund Reason"
                                                    value={reason}
                                                    onChange={(e) => handleFieldChange(e, "reason")}

                                                />
                                                {error?.reason && (
                                                    <span className="text-danger" style={{ fontSize: "12px" }}>
                                                        {error.reason}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt-3">
                                        {!isEditing && (
                                            <button
                                                onClick={handleSubmit}
                                                type="submit"
                                                className="btn btn-primary"
                                            >
                                                Submit
                                            </button>
                                        )}
                                        {isEditing && (
                                            <button
                                                onClick={handleSubmit}
                                                type="submit"
                                                className="btn btn-primary"
                                            >
                                                Update
                                            </button>
                                        )}
                                        <button onClick={handleCancel} className="btn btn-light ms-2">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
            <RefundReasonList />
        </div>

    );
};

export default RefundReason;